import { Divider } from "antd";
import StatementView from "./StatementView";

export default function StatementsList({ statements }) {
    return (
        <ol>
            {statements.map((statement, index) => (
                <li key={index}>
                    <StatementView statement={statement} />
                    <Divider />
                </li>
            ))}
        </ol>
    );
}